webpackJsonp([5],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_js__ = __webpack_require__(15);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
	userInfo: null
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: state,
	mutations: __WEBPACK_IMPORTED_MODULE_2__mutations_js__["a" /* default */],
	actions: __WEBPACK_IMPORTED_MODULE_3__actions_js__["a" /* default */],
	getters: {
		getUserInfo: function getUserInfo(state) {
			return state.userInfo;
		}
	}
}));

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(35);



var List = function List(resolve) {
	__webpack_require__.e/* require.ensure */(2).then((function () {
		resolve(__webpack_require__(40));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Topic = function Topic(resolve) {
	__webpack_require__.e/* require.ensure */(0).then((function () {
		resolve(__webpack_require__(42));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Login = function Login(resolve) {
	__webpack_require__.e/* require.ensure */(1).then((function () {
		resolve(__webpack_require__(41));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Edit = function Edit(resolve) {
	__webpack_require__.e/* require.ensure */(3).then((function () {
		resolve(__webpack_require__(39));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		name: "root",
		path: '/',
		redirect: "/list"
	}, {
		name: 'list',
		path: '/list',
		component: List
	}, {
		name: "topic",
		path: '/topic/:id',
		component: Topic
	}, {
		name: "login",
		path: '/login',
		component: Login
	}, {
		name: "edit",
		path: '/edit',
		component: Edit,
		meta: {
			requiresAuth: true
		}
	}]
}));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(33)

var Component = __webpack_require__(10)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(34),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_assets_style_common_less__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_assets_style_common_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_assets_style_common_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_assets_style_iconfont_css__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_assets_style_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__src_assets_style_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_assets_style_github_markdown_css__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_assets_style_github_markdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__src_assets_style_github_markdown_css__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {}
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index_js__ = __webpack_require__(4);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

if (window.sessionStorage.getItem("userInfo")) {
	__WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */].dispatch("setUserInfo", JSON.parse(window.sessionStorage.getItem("userInfo")));
}

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
	console.log(__WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */].getters.getUserInfo);

	if (to.matched.some(function (record) {
		return record.meta.requiresAuth;
	})) {
		if (!__WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */].getters.getUserInfo) {
			__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
				name: 'login',
				query: {
					'returnUrl': to.fullPath
				}
			});
		} else {
			next();
		}
	} else {
		next();
	}
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	setUserInfo: function setUserInfo(_ref, payload) {
		var commit = _ref.commit;

		commit("SET_USERINFO", payload);
	}
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

var SET_USERINFO = "SET_USERINFO";

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, SET_USERINFO, function (state, payload) {
	state.userInfo = payload;
}));

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}

/***/ })
],[14]);


// WEBPACK FOOTER //
// static/js/app.70d7a9480dd253ad731a.js